import { render } from "./NavigationBarBottom.vue?vue&type=template&id=44951994&scoped=true"
import script from "./NavigationBarBottom.vue?vue&type=script&lang=js"
export * from "./NavigationBarBottom.vue?vue&type=script&lang=js"

import "./NavigationBarBottom.vue?vue&type=style&index=0&id=44951994&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44951994"]])

export default __exports__